import { BloctoWallet } from '@thirdweb-dev/wallets';

const bloctoWallet = options => ({
  id: BloctoWallet.id,
  meta: BloctoWallet.meta,
  create(walletOptions) {
    return new BloctoWallet({
      ...walletOptions,
      ...options
    });
  },
  isInstalled() {
    return false;
  }
});

export { bloctoWallet };
